import React, {useMemo} from "react";
import {backgroundColorList} from "../../utils/dashboardUtils";

const CourseConfigChart = ({period, courseList, onePointWidth}) => {
    const content = useMemo(() => {
        if (!period?.levelPointsConfig?.length) return null;

        const courseListAcc = {};
        const levelDefinition = period.levelPointsConfig.reduce((acc, lpc) => {
            acc[lpc._id] = {...lpc, count: 0};
            courseListAcc[lpc._id] = [];
            return acc;
        }, {});
        const levelCourseList = courseList.reduce((acc, course) => {
            const levelId = levelDefinition[course.level]?._id;
            if (levelId) acc[levelId].push(course);
            return acc;
        }, courseListAcc);

        let height = 0;

        const rows = Object.entries(levelCourseList).map(([levelId, list], i) => {
            const {min, max} = levelDefinition[levelId];
            const width = (max - min) * onePointWidth;
            const barStyle = { width: `${width}%`, left: `${min * onePointWidth}%` };

            let totalTop = 0;
            const color = backgroundColorList[i];

            const labels = list.map((course) => {
                const top = `${totalTop += 20}px`;
                const labelStyle = { color, position: "relative", top: totalTop + 60 };

                return (
                    <div className="dashboard-charts-level-points-bar" key={`${levelId}-${course._id}`} style={{...barStyle, top}}>
                        <p style={labelStyle}>{`Kurz ${course.code}`}</p>
                        {totalTop === 20 && <div style={{backgroundColor: color}}/>}
                        {totalTop === 20 && <label style={{color}}>{`${min}b`}</label>}
                        {totalTop === 20 && <label style={{color}}>{`${max}b`}</label>}
                    </div>
                );
            });

            if (height < totalTop) height = totalTop;
            return labels;
        });

        return {rows, height};
    }, [period, courseList, onePointWidth]);

    if (!content) return null;

    return (
        <div style={{height: content.height + 60}}>
            {content.rows}
        </div>
    );
};

export default CourseConfigChart;
